import { render, staticRenderFns } from "./DiningBoard.vue?vue&type=template&id=0797f01d&scoped=true"
import script from "./DiningBoard.vue?vue&type=script&lang=js"
export * from "./DiningBoard.vue?vue&type=script&lang=js"
import style0 from "./DiningBoard.vue?vue&type=style&index=0&id=0797f01d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0797f01d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0797f01d')) {
      api.createRecord('0797f01d', component.options)
    } else {
      api.reload('0797f01d', component.options)
    }
    module.hot.accept("./DiningBoard.vue?vue&type=template&id=0797f01d&scoped=true", function () {
      api.rerender('0797f01d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/cashier/DiningBoard.vue"
export default component.exports